<template>
  <div
    class="statistics-page @apply border border-border rounded-lg overflow-hidden"
  >
    <iframe :src="iframeSrc" class="statistics-iframe" />
  </div>
</template>

<script>
export default {
  name: "StatisticsList",
  computed: {
    iframeSrc() {
      return "https://timetoask.ai/#/reports";
    },
  },
};
</script>

<style scoped lang="scss">
.statistics-page {
  width: 100%;
  height: 100%;

  .statistics-iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
}
</style>
